'use strict';

// import throttle from './throttle.js';
// import lottie from 'lottie-web';
// import menuLottie from './menu.lottie.json';
import delegateEvent from './delegateEvent.js';
import closestParent from './closestParent.js';

export default class TimetableHandler {
    constructor() {
        this.timetable = document.querySelector('.w-timetable');
        if (!this.timetable) return;

        this.autoplay = true;
        this.autoplayTime = 4000;
        this.setStep(1); // begin

        delegateEvent(document, 'click', '[data-w-timetable-trigger]', (e) => {
            this.autoplay = false; // stop autplay when interacting

            const num = e.target.getAttribute('data-w-timetable-trigger');
            this.setStep(num);
        });

        const autoplay = () => {
            let step = this.step;
            step++;
            if (step > 3) step = 1;
            this.setStep(step);

            if (this.autoplay) {
                setTimeout(() => {
                    if (this.autoplay) {
                        autoplay();
                    }
                }, this.autoplayTime);
            }
        };
        setTimeout(() => {
            autoplay();
        }, this.autoplayTime);
    }

    setStep(num) {
        this.step = num;

        this.timetable.setAttribute('data-w-timetable-step', num);
        const step = this.timetable.querySelector(
            '[data-w-timetable-trigger="' + num + '"]'
        );

        const learnText = step.getAttribute('data-w-timetable-learn');
        const trainText = step.getAttribute('data-w-timetable-train');
        const learnLabel = this.timetable.querySelector(
            '[data-w-timetable-value="learning"]'
        );
        const trainLabel = this.timetable.querySelector(
            '[data-w-timetable-value="training"]'
        );
        learnLabel.innerHTML = learnText;
        trainLabel.innerHTML = trainText;
    }
}
